import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import {
    listKnowledge,
    upsertCustomQuestions,
    deleteCustomQuestions
} from '../api/kuizy'

function ImportExamModal({
    examId,
    value,
    onChange,
    customId,
    setCustomId,
    mode,
    setMode,
    shuffleOptions,
    setShuffleOptions
}) {
 
    const load = async () => {
        if (!examId) return
        const { data } = await listKnowledge(examId)
        const cq = data?.custom_questions?.[0]
        if (!cq) return

        onChange(cq.text || '')
        setCustomId(cq.id)
        setMode('edit')
    }
    
    useEffect(() => {
        load()
    }, [examId])
 

    const handleSave = async () => {
        await upsertCustomQuestions({
            exam_id: examId,
            text: value
        })
        setMode('edit')
        await load()
    }

    const handleDelete = async () => {
        if (!confirm('ต้องการลบข้อสอบนี้หรือไม่')) return

        await deleteCustomQuestions({ exam_id: examId })
        onChange('')
        setMode('create')
        await load()
    }


    const fadeUp = { initial: { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0 } }

    return (
        <motion.div {...fadeUp} transition={{ duration: 0.35 }} className="flex flex-col gap-4">
            <div className="border border-dashed border-primary/60 rounded-xl p-4 bg-primary/5">
                <h4 className="font-semibold text-primary mb-2">📝 เพิ่มข้อสอบของคุณ</h4>

                <textarea
                    value={value}
                    onChange={e => onChange(e.target.value)}
                    rows={15}
                    placeholder=" ตัวอย่าง
1. แม่ซื้อแอปเปิลมา 4 ลูก กินไปแล้ว 1 ลูก ตอนนี้เหลือแอปเปิลกี่ลูก
    1. 1 ลูก
    2. 2 ลูก
    3. 3 ลูก
    4. 4 ลูก
    เฉลย: 3. 3 ลูก
 
2. ถ้านักเรียนไปโรงเรียนตอนเช้า และต้องใช้สิ่งของเพื่อเขียนการบ้าน สิ่งใดเหมาะสมที่สุด
    a. ช้อน
    b. ดินสอ
    c. แปรงสีฟัน
    d. รองเท้า
    (ไม่มีเฉลย — ให้ AI หาคำตอบ)"
                    className="w-full font-mono text-sm border rounded-lg p-3 focus:ring-2 focus:ring-primary"
                />
            </div>

            <label className="flex items-center gap-2 text-sm">
                <input
                    type="radio"
                    name="shuffle"
                    checked={!shuffleOptions}
                    onChange={() => setShuffleOptions(false)}
                />
                ใช้ตัวเลือกเดิมตามลำดับที่พิมพ์
            </label>

            <label className="flex items-center gap-2 text-sm">
                <input
                    type="radio"
                    name="shuffle"
                    checked={shuffleOptions}
                    onChange={() => setShuffleOptions(true)}
                />
                ให้ AI สลับตัวเลือก
            </label>


            <div className="flex justify-end gap-2">
                {mode === 'edit' && (
                    <button
                        onClick={handleDelete}
                        className="px-4 py-2 rounded-lg border text-red-600"
                    >
                        ลบ
                    </button>
                )}

                <button
                    onClick={handleSave}
                    disabled={!value.trim()}
                    className="px-4 py-2 rounded-lg bg-primary text-white disabled:opacity-50"
                >
                    {mode === 'edit' ? 'บันทึกการแก้ไข' : 'เพิ่มข้อสอบ'}
                </button>
            </div>
        </motion.div>
    )
}

export default ImportExamModal
